"use client";

import React, { useMemo } from "react";
import { CompanyQuickBooksCustomerConnections } from "./CompanyQuickBooksCustomerConnections";
import { QuickBooksActions } from "@/components/quickbooks/connection/QuickBooksActions";
import { QuickBooksInvoiceViewer } from "@/components/quickbooks/invoice/QuickBooksInvoiceViewer";
import { useCompanyQuickBooksCustomer } from "@/features/companies/hooks/company-quickbooks-hooks";
import { useCompanyContacts } from "@/lib/hooks/api/companies";

export interface CompanyQuickBooksPanelProps {
  companyId: string;
  /** Display label for QB actions / invoice viewer (CRM company name) */
  companyDisplayName: string;
}

/** QuickBooks integrations scoped to one CRM **companies.id** row. */
export function CompanyQuickBooksPanel({
  companyId,
  companyDisplayName,
}: CompanyQuickBooksPanelProps) {
  const { data: qbData } = useCompanyQuickBooksCustomer(companyId);
  const { data: companyContacts } = useCompanyContacts(companyId, { limit: 1 });
  const primaryContactId = useMemo(() => companyContacts?.[0]?.id, [companyContacts]);

  return (
    <div className="space-y-4">
      <CompanyQuickBooksCustomerConnections companyId={companyId} />
      <QuickBooksActions
        qbCustomerId={qbData?.quickbooksCustomerRef || undefined}
        qbDisplayName={qbData?.quickbooksCustomerName || companyDisplayName}
        companyId={companyId}
        companyName={companyDisplayName}
      />
      <QuickBooksInvoiceViewer contactId={primaryContactId} customerName={companyDisplayName} />
    </div>
  );
}
